import type { Source } from "./types";

export const getSources = (path: string): ReadonlyArray<Source> => {
    const gltfUrl = new URL(path, window.location.href);

    const { origin } = gltfUrl;

    return [
        {
            name: "environmentMapTexture",
            type: "cubeTexture",
            path: [
                `${origin}/3d-configurator/textures/environmentMaps/0/px.png`,
                `${origin}/3d-configurator/textures/environmentMaps/0/nx.png`,
                `${origin}/3d-configurator/textures/environmentMaps/0/py.png`,
                `${origin}/3d-configurator/textures/environmentMaps/0/ny.png`,
                `${origin}/3d-configurator/textures/environmentMaps/0/pz.png`,
                `${origin}/3d-configurator/textures/environmentMaps/0/nz.png`,
            ],
        },
        {
            name: "model",
            type: "gltfModel",
            path,
        },
    ] satisfies ReadonlyArray<Source>;
};
